import auth from 'dash-front/auth';
export default auth;
// temporarty unify AUTH
//
//
// class Auth {
//     _user = null;
//     _token = null;

//     get getUser() {
//         if (this._user) return this._user;

//         const serializedUser = localStorage.getItem('user');
//         if (!serializedUser) return null;
//         this._user = JSON.parse(serializedUser);

//         return this._user;
//     }

//     get getAccessToken() {
//         return this._token || localStorage.getItem('accessToken');
//     }

//     get loggedIn() {
//         return Boolean(this.getAccessToken && this.getUser);
//     }

//     saveUser(user) {
//         user.props = (user.defaultProps || []).reduce(
//             (memo, { key, value }) => {
//                 try {
//                     memo[key] = JSON.parse(value);
//                 } catch (e2) {
//                     memo[key] = value;
//                 }

//                 return memo;
//             },
//             { lang: 'en' },
//         );

//         localStorage.setItem('user', JSON.stringify(user));

//         this._user = user;
//     }

//     saveAccessToken(token) {
//         localStorage.setItem('accessToken', token);
//         this._token = token;

//         return this._token;
//     }

//     logout() {
//         localStorage.removeItem('user');
//         localStorage.removeItem('accessToken');

//         this._token = null;
//         this._user = null;
//     }

//     hasAdminRights() {
//         return this.loggedIn && (this.getUser.roles || []).indexOf('admin') >= 0;
//     }
// }

// if (process.env.NODE_ENV === 'dev') {
//     window.auth = new Auth();
// }

// export default new Auth();



/** WEBPACK FOOTER **
 ** ../src/dash/front-v2/auth.js
 **/